<script>
    import FileBlock from "./FileBlock.svelte";
    import FolderBlock from "./FolderBlock.svelte";
    import { t } from "../../../i18n";


    export let header = null;


    export let path;
    export let content = [];

    $: empty = !content || !content.length;
    $: files = content && content.filter(o=>!o.dir);
    $: folders = content && content.filter(o=>o.dir);

</script>



<div class="app-file-content p-2">
    {#if header}<h5>{header}</h5>{/if}
    {#if empty}{$t('files.empty')}{/if}


    {#if folders&&folders.length}
    <label class="app-file-label">{$t('files.folder')}</label>
    <div class="row app-file-folder">
        {#each folders as folder} <FolderBlock {...folder}></FolderBlock> {/each}
    </div>
    {/if}

    {#if files&&files.length}
        <label class="app-file-label">{$t('files.files')}</label>
        <div class="row app-file">
            {#each files as file} <FileBlock {...file} path={path}></FileBlock> {/each}
        </div>
    {/if}

</div>